<template>
  <div id="scrap-list" class="content">
    <div class="header">
      <h1>{{ pageTitle }}</h1>
    </div>
    <div id="content-body form-wrapper quote-form-wrapper left">
      <Row class="margin-bottom-20" type="flex" align="middle">
        <Col span="8">
          <Input search enter-button :placeholder="$t('quality.scrap_list.search_placeholder')" v-model="keyword" @on-search="handleSearch"/>
        </Col>
        <Col span="4" class="margin-left-20">
          <Checkbox v-model="noScrap">{{ $t('quality.scrap.no_scrap_check') }}</Checkbox>
        </Col>
        <Col span="4" offset="4">
          <div>
            <h2>{{ setScrapRate }}%</h2>
            <p class="margin-left-20">{{ $t('quality.scrap.scrap_tip') }}</p>
          </div>
        </Col>
      </Row>

      <div style="overflow-x: auto">
        <Table :loading="loading" :columns="columns" :data="tableData" stripe border highlight-row>
        <template slot-scope="{ row, column, index }" slot="propsCell">
          {{_.get(row, column.key)}}
        </template>
        <template slot-scope="{ row, column, index }" slot="propsFormatCell">
          {{roundNum(_.get(row, column.key) * 100, 4)}}
        </template>
        <template slot-scope="{ row, column, index }" slot="baseInfoCell">
          <div>
              <div>
                <p>{{ row.part_number }}</p>
                <p>{{ row.brand }} <span
                  v-if="(row.source_model && row.source_model.component_type === 'electronic_part') || !row.manufacturer_part_id">{{ row.mpn }}</span>
                </p>
                <p>{{ row.name }}</p>
                <p
                  v-if="(row.source_model && row.source_model.component_type !== 'electronic_part') || !row.manufacturer_part_id">
                  {{ row.specification }}
                </p>
              </div>
            </div>
        </template>
        <template slot-scope="{ row, column, index }" slot="bomInfoCell">
          <div class="flex" v-if="row.bom_usage && row.bom_usage.length">
            <div>
              <p>
                <router-link :to="{ name: 'menu.bom.view', params: { 'bomId': row.bom_usage[0].bom_id } }" target="_blank">
                  <span v-if="row.bom_usage[0].part_number">{{row.bom_usage[0].part_number}}</span>
                  <span v-else> {{row.bom_usage[0].bom_name}}</span>
                  <span class="margin-left-10">{{roundNum(row.bom_usage[0].scrap_rate * 100, 4)}}%</span>
                </router-link>
              </p>
              <p v-if="row.bom_usage.length > 1">
                <router-link :to="{ name: 'menu.bom.view', params: { 'bomId': row.bom_usage[1].bom_id } }" target="_blank">
                  <span v-if="row.bom_usage[1].part_number">{{row.bom_usage[1].part_number}}</span>
                  <span v-else> {{row.bom_usage[1].bom_name}}</span>
                  <span class="margin-left-10">{{roundNum(row.bom_usage[1].scrap_rate * 100, 4)}}%</span>
                </router-link>
              </p>
              <p v-if="row.bom_usage.length > 2">
                <router-link :to="{ name: 'menu.bom.view', params: { 'bomId': row.bom_usage[2].bom_id } }" target="_blank">
                  <span v-if="row.bom_usage[2].part_number">{{row.bom_usage[2].part_number}}</span>
                  <span v-else> {{row.bom_usage[2].bom_name}}</span>
                  <span class="margin-left-10">{{roundNum(row.bom_usage[2].scrap_rate * 100, 4)}}%</span>
                </router-link>
              </p>
            </div>
            <div v-if="row.bom_usage.length > 3">
              <Poptip :placement="index < 10 ? 'right-start' : 'right-end'">
                <Icon type="md-more" size="16" class="cursor"/>
                <div slot="content">
                  <p v-for="item in row.bom_usage" :key="item.bom_id">
                    <router-link :to="{ name: 'menu.bom.view', params: { 'bomId': item.bom_id } }" target="_blank">
                      <span v-if="item.part_number">{{item.part_number}}</span>
                      <span v-else> {{item.bom_name}}</span>
                      <span class="margin-left-10">{{roundNum(item.scrap_rate * 100, 4)}}%</span>
                    </router-link>
                  </p>
                </div>
              </Poptip>
            </div>
          </div>
        </template>
        <template slot-scope="{ row, column, index }" slot="actionCell">
          <div>
            <Tooltip content="Edit" transfer>
              <Icon type="md-create" color="#2D8cF0" size="14" class="cursor" @click="handleEditScrap(row)"/>
            </Tooltip>
            <Tooltip content="Look history" transfer>
              <Icon type="md-timer" class="margin-left-10 cursor" color="#2D8cF0" size="14" @click="handleShowHistory(row)"/>
            </Tooltip>
          </div>
        </template>
      </Table>
      <div class="margin-top-10 text-align-right ">
        <Page :total="total" :page-size="pageSize" :current="currentPage" @on-change="onChangePage" show-elevator
              show-total></Page>
      </div>
      </div>
    </div>
    <Modal
      v-model="showEditModel"
      :title="$t('quality.scrap.edit_model_title')"
      footer-hide transfer width="30%">
      <div>
        <p class="warning margin-bottom-20">{{ $t('quality.scrap.edit_model_tip') }}</p>
        <Form :model="editForm" label-position="top">
        <FormItem label="Scrap(%)">
            <Input v-model="editForm.scrap_rate"></Input>
        </FormItem>
        <FormItem label="Note">
            <Input v-model="editForm.note" type="textarea"></Input>
        </FormItem>
        <FormItem class="text-align-right">
            <Button @click="showEditModel = false">{{ $t('form.cancel') }}</Button>
            <Button type="primary" class="margin-left-20" @click="handleSubmit()">{{ $t('form.save') }}</Button>
        </FormItem>
    </Form>
      </div>
    </Modal>
    <Modal
      v-model="showHistoryModel"
      :title="$t('quality.scrap.history_model_title')"
      footer-hide transfer width="60%">
      <ScrapHistory v-if="selectedId" :id="selectedId"></ScrapHistory>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from "vuex"
import { intlCurrencyNumber, roundNum } from '@/libs/util'
import ScrapHistory from './components/form/scrap-history'

export default {
  name: "ScrapList",
  components: {
    ScrapHistory
  },
  data() {
    return {
      noScrap: false,
      tableData: [],
      columns: [
        {
          type: 'index',
          width: 50,
          align: 'center'
        },
        {
          key: 'name',
          title: 'Display name',
          align: 'left',
          slot: 'baseInfoCell',
          minWidth: 160
        },
        {
          key: 'scrap_rate',
          title: 'Default scrap(%)',
          align: 'left',
          slot: 'propsFormatCell',
          minWidth: 80
        },
        {
          key: 'bom_usage',
          title: 'BOM',
          align: 'left',
          slot: 'bomInfoCell',
          minWidth: 160
        },
        {
          key: 'scrap.note',
          title: 'Notes',
          align: 'left',
          slot: 'propsCell',
          minWidth: 160
        },
        {
          key: 'action',
          title: 'Actions',
          align: 'center',
          slot: 'actionCell',
          minWidth: 80
        }
      ],
      keyword: '',
      total: 0,
      currentPage: 1,
      pageSize: 20,
      loading: false,
      showEditModel: false,
      showHistoryModel: false,
      selectedId: null,
      editForm: {
        scrap_rate: 0,
        note: ''
      },
      partId: null,
      showBomMore: false,
      setScrapRate: 0
    }
  },
  computed: {
    pageTitle () {
      document.title = this.$t('quality.scrap.title')
      return document.title
    }
  },
  mounted () {
    this.handleLoadList()
  },
  methods: {
    ...mapActions([
      'getQualityDataList',
      'setPartScrap'
    ]),
    intlCurrencyNumber,
    roundNum,
    handleLoadList () {
      let query_raw = {
        bool: {
          minimum_should_match: 0
        }
      }
      if (this.keyword.length > 0) {
        query_raw.bool.should = [
          {
            match: {
              "mpn.raw": this.keyword
            }
          },
          {
            match: {
              "chinese_name.raw": this.keyword
            }
          },
          {
            match: {
              "name": this.keyword
            }
          },
          {
            match: {
              "part_number.raw": this.keyword
            }
          },
          {
            nested: {
              path: "bom_usage",
              query: {
                bool: {
                  should: [
                    {
                      match: {
                        "bom_usage.bom_name": this.keyword
                      }
                    },
                    {
                      match: {
                        "bom_usage.part_number": this.keyword
                      }
                    }
                  ]
                }
              }
            }
          }
        ]
        query_raw.bool.minimum_should_match = 1
      }
      if (this.noScrap) {
        query_raw.bool.must_not = [
          {
            exists: { "field": "scrap_rate" }
          }
        ]
      }
      const data = {
        query_raw: query_raw,
        appends: ["scrap_rate", "bom_usage"],
        includes: ['scrap'],
        page: this.currentPage,
        size: this.pageSize,
        sort: { "scrap_rate": "desc" },
        "aggs": {
          "scrap_count": {
            "filter": {
              "exists": {
                "field": "scrap_rate"
              }
            }
          }
        }
      }
      this.loading = true
      this.getQualityDataList({ modelType: 'manufacturer_part', data }).then(res => {
        if (res.data.length > 0) {
          this.setScrapRate = _.round(res.aggs.scrap_count.doc_count / res.meta.total * 100, 2)
        } else {
          this.setScrapRate = 0
        }
        this.tableData = res.data
        this.total = res.meta.total
        this.currentPage = res.meta.current_page
        this.pageSize = res.meta.per_page
        this.loading = false
      }).finally(() => {
        this.loading = false
      })
    },
    handleSearch () {
      this.currentPage = 1
      this.handleLoadList()
    },
    onChangePage (page) {
      this.currentPage = page
      this.handleLoadList()
    },
    handleEditScrap (row) {
      this.showEditModel = true
      this.editForm.scrap_rate = this.roundNum(row.scrap?.scrap_rate * 100, 4) || 0
      this.editForm.note = row.scrap?.note || ''
      this.partId = row.scrap?.manufacturer_part_id || row.id
    },
    handleSubmit () {
      let submitFormData = _.cloneDeep(this.editForm)
      submitFormData.scrap_rate = this.roundNum(submitFormData.scrap_rate / 100, 4)
      this.setPartScrap({ partId: this.partId, data: submitFormData }).then(res => {
        this.$Message.success("Edit successfully")
        this.handleLoadList()
        this.showEditModel = false
      })
    },
    handleShowHistory (row) {
      this.showHistoryModel = true
      this.selectedId = row.id
    }
  },
  watch: {
  }
}
</script>

<style lang="less">
#scrap-list {
  .cursor {
    cursor: pointer;
  }
  .flex {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  .ivu-poptip-body-content {
    max-height: 300px;
    overflow-y: auto;
  }
}
</style>
